import * as Y from 'yjs'
import {DATABASE_COLUMN_NAME_MAX_CHARS} from '../../../utils/constants'

 









const defaultColumnMeta = {
  name: 'New column',
  type: 'text'
}

const generateId = (_doc) => {
  return crypto.randomUUID()
}

export const getRows = (doc) => {
  return doc.getArray('rows')
}

export const getColumns = (doc) => {
  return doc.getArray('columns')
}

export const changeColumn = (doc, columnId, newMeta) => {
  const columnMeta = doc.getMap('columnMeta')
  columnMeta.set(columnId, {
    ...newMeta,
    name: newMeta.name.substring(0, DATABASE_COLUMN_NAME_MAX_CHARS)
  })
}

export const insertColumnAt = (doc, index, meta = defaultColumnMeta) => {
  const id = generateId(doc)
  doc.transact(() => {
    changeColumn(doc, id, meta)
    const columns = doc.getArray('columns')
    columns.insert(index, [id])
  })
  return id
}

export const appendColumn = (doc, meta = defaultColumnMeta) => {
  const id = generateId(doc)
  doc.transact(() => {
    changeColumn(doc, id, meta)
    const columns = doc.getArray('columns')
    columns.push([id])
  })
  return id
}

export const duplicateColumn = (doc, columnId) => {
  const id = generateId(doc)
  doc.transact(() => {
    const columnMeta = doc.getMap('columnMeta')
    const existingMeta = columnMeta.get(columnId)
    if (!existingMeta) {
      throw new Error(`Column meta not found for columnId: ${columnId}`)
    }
    columnMeta.set(id, {...existingMeta})

    const data = doc.getMap('data')
    data.forEach((value) => {
      const source = value.get(columnId)
      if (source !== undefined) {
        value.set(id, source)
      }
    })

    const columns = doc.getArray('columns')
    const index = columns.toArray().indexOf(columnId)
    columns.insert(index + 1, [id])
  })
  return id
}

export const deleteColumn = (doc, columnId) => {
  doc.transact(() => {
    const columns = doc.getArray('columns')
    const index = columns.toArray().indexOf(columnId)
    columns.delete(index, 1)

    const data = doc.getMap('data')
    data.forEach((row) => {
      row.delete(columnId)
    })
  })
}

export const appendRow = (doc) => {
  const id = generateId(doc)
  doc.transact(() => {
    const rows = doc.getArray('rows')
    const data = doc.getMap('data')
    data.set(id, new Y.Map())
    rows.push([id])
  })
  return id
}

export const deleteRow = (doc, rowId) => {
  doc.transact(() => {
    const rows = doc.getArray('rows')
    const index = rows.toArray().indexOf(rowId)
    if (index !== -1) {
      rows.delete(index, 1)
    }

    const data = doc.getMap('data')
    data.delete(rowId)
  })
}
